import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";

export const staticWelcomePageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.staticWelcome(),
    queryFn: () => fetchOccPageData<PageInitialDataResult<void>>("/page-data/static/welcome"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
